<div class="person-explorer-emails-sent-part">
	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="personExplorer.explorer.customGridHeight()" [rows]="emailsSent()"></grid-content>
</div>